import {EventEmitter} from 'events'
import AppDispatcher from '../AppDispatcher'
import React from 'react'
import _ from 'lodash'

import {Alert} from 'antd'

export class NotifyStore extends EventEmitter {
   constructor() {
      super()

      this._notifications = []
   }

   subscribe(subscription) {
      this._dispatchToken = AppDispatcher.register(subscription)
   }

   get dispatchToken() {
      return this._dispatchToken
   }

   emitChange() {
      this.emit('CHANGE')
   }

   addChangeListener(cb) {
      this.on('CHANGE', cb)
   }

   removeChangeListener(cb) {
      this.removeListener('CHANGE', cb)
   }

   get notifications() {
      return this._notifications
   }

   get length() {
      return this._notifications.length
   }

   clear() {
      this._notifications = []
      this.emitChange()
   }

   remove(ref) {
      this._notifications = _.filter(this.notifications, note => ref !== note.ref)
      this.emitChange()
   }

   add(message, style, inopts) {
      this._notifications = []

      let opts = inopts || {}
      let ref = Math.random().toString(36).replace(/^0\./, ''),
         notifications = this._notifications

      if (opts.clearOut) {
         notifications = []
      }

      let prev = _.where(notifications, {message: message, style: style})

      if (0 < prev.length) {
         return prev.ref
      }

      notifications.push({
         message: message,
         style:   style,
         ref:     ref
      })

      this._notifications = notifications
      this.emitChange()

      if (opts.expire) {
         setTimeout(() => this.remove(ref), opts.expire)
      }

      return ref
   }
}

export class Notify extends React.Component {
   static get propTypes() {
      return {
         store: React.PropTypes.instanceOf(NotifyStore)
      }
   }

   constructor() {
      super()
      this.state = {
         notifications: []
      }
   }

   componentDidMount() {
      this.props.store.addChangeListener(
         (this._listener = () => this.setState({notifications: this.props.store.notification})),
      )
   }

   componentWillUnmount() {
      this.props.store.removeChangeListener(this._listener)
   }

   render() {
      return (
         <div>
            {this.props.store.notifications.map(note => (
               <Alert
                  showIcon
                  key={note.ref}
                  type={note.style}
                  message={_.isFunction(note.message) ? note.message() : note.message}
               />
            ))}
         </div>
      )
   }
}

Notify.Store = NotifyStore



// WEBPACK FOOTER //
// lib/ui/Notify.jsx